import React, { useState, useEffect } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
	Alert,
} from 'reactstrap';

import { toast } from 'react-toastify';
import { Icons } from '../../../utils/Icons';

const DeletePhotographicRecordModal = ({
    dataPhotographicRecord,
    isOpen,
    handleToggleModal,
	photographicRecordsList,
	handlePhotographicRecordsList
}) => {
	// const dispatch = useDispatch();

    const [isDeleting, setIsDeleting] = useState();

	function handleDelete() {
		const recordIndex = photographicRecordsList.findIndex((photographicRecord) => {
			const recordId = photographicRecord?.id || photographicRecord?.document_id;
			const candidateId = dataPhotographicRecord?.id || dataPhotographicRecord?.document_id;
			return recordId && candidateId
				? recordId === candidateId
				: photographicRecord === dataPhotographicRecord;
		});

		if (recordIndex >= 0) {
			toast.success(`Registro fotográfico eliminado exitosamente.`, { autoClose: 3000 });
			const updatedGuideDetailList = photographicRecordsList.filter((_, index) => index !== recordIndex);
			handlePhotographicRecordsList(updatedGuideDetailList);
        }
        handleToggleModal(!isOpen);
	}


	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handleToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader className='modal-title' />
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<h3 className='mb-3'>
							¡Estás a punto de eliminar un registro fotográfico!
						</h3>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en
							confirmar.
						</p>
						<p className='small'>
							Archivo: {
								dataPhotographicRecord !== null
									? (
										Array.isArray(dataPhotographicRecord?.document) && dataPhotographicRecord.document.length
											? dataPhotographicRecord.document[0].filename + dataPhotographicRecord.document[0].extension
											: dataPhotographicRecord?.document?.name || ''
									)
									: ''
							}
						</p>
						<div className='hstack gap-2 justify-content-center'>
							<Button className='btn-danger btn-label' onClick={() => handleToggleModal()}><i className='icon-x label-icon'></i> Cancelar</Button>
							<button className='btn btn-label btn-primary' onClick={() => handleDelete()} disabled={isDeleting}>{isDeleting ? (<i className='label-icon'><Spinner size='sm' /></i>) : <i className={`${Icons.check2} label-icon`}></i>} Confirmar</button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default DeletePhotographicRecordModal;
